export const tableColumns = () => {
  return [
    {
      field: 'contractCode',
      title: '合同编号',
      width: '200',
      className: 'link-color',
    },
    {
      field: 'contractName',
      title: '合同名称',
      width: '280',
    },
    {
      field: 'contractType',
      title: '合同类型',
      width: '120',
    },
    {
      field: 'effectiveDate',
      title: '生效日期',
      width: '200',
    },
  ];
};
